import ClickAwayListener from '@mui/material/ClickAwayListener';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import { makeStyles } from 'tss-react/mui';
import ShareIcon from '@mui/icons-material/Share';
import React, { useState } from 'react';
import PostSocialShares from '../Post/PostSocialShares';
import RoundNavIconBtn from './RoundNavIconBtn';

const useStyles = makeStyles()(() => ({
  paper: {
    padding: '17px 5px 4px 5px',
    borderRadius: 16,
    boxShadow:
      '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23),  0 -1px 3px -1px rgba(0, 0, 0, 0.2)',
  },
}));

const ShareButton = props => {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClose = event => {
    if (anchorEl && anchorEl.contains(event.target)) {
      return;
    }

    setAnchorEl(null);
    setOpen(false);
  };

  const { classes } = useStyles();

  const { author, permlink, tags, title, thumbnail } = props.socialShare;
  let tagString = '';
  if (tags)
    tags.forEach((t, i) => {
      if (i > 0) tagString += ', ';
      tagString += `#${t}`;
    });

  const browserShare = e => {
    //   Use native sharing if available
    if (navigator.share)
      navigator.share({
        title,
        text: `${title} ${tagString}`,
        url: window.location.href,
      });
    else {
      setAnchorEl(anchorEl ? null : e.currentTarget);
      setOpen(true);
    }
  };

  return (
    <>
      <RoundNavIconBtn onClick={browserShare} aria-label="Share">
        <ShareIcon />
      </RoundNavIconBtn>
      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="bottom"
        disablePortal={false}
        modifiers={{
          flip: {
            enabled: true,
          },
          preventOverflow: {
            enabled: true,
            boundariesElement: 'scrollParent',
          },
        }}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <Paper className={classes.paper}>
            <PostSocialShares
              author={author}
              permlink={permlink}
              tags={tags}
              title={title}
              thumbnail={thumbnail}
            />
          </Paper>
        </ClickAwayListener>
      </Popper>
    </>
  );
};

export default ShareButton;
